import React, { createContext, useContext, useMemo } from 'react';

const BlueOxHostContext = createContext({ user: null });

export function BlueOxHostProvider({ user = null, children }) {
  const value = useMemo(() => ({ user }), [user]);
  return (
    <BlueOxHostContext.Provider value={value}>
      {children}
    </BlueOxHostContext.Provider>
  );
}

export function useBlueOxUser() {
  return useContext(BlueOxHostContext).user ?? null;
}
